"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.replaceLinks = void 0;
// Function for replacing links in text in a pipeable way
var replaceLinks = function(textLinks) {
    return function(inputText) {
        if (!textLinks || textLinks.length === 0) {
            return inputText;
        }
        return inputText.replaceAll(/{(\d+)}/g, function(_, index) {
            var link = textLinks[Number.parseInt(index, 10)];
            if (!link) {
                return '';
            }
            var _link_relativeUrl;
            var url = (_link_relativeUrl = link.relativeUrl) !== null && _link_relativeUrl !== void 0 ? _link_relativeUrl : '#';
            var _link_title;
            var title = (_link_title = link.title) !== null && _link_title !== void 0 ? _link_title : 'Link';
            return '<a data-index="'.concat(index, '" href="').concat(url, '">').concat(title, "</a>");
        });
    };
};
exports.replaceLinks = replaceLinks; //# sourceMappingURL=replaceLinks.js.map
